import React, {useState, useRef} from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css'
import '../../../css/addbusinesssheet.scss';
import APICall from '../../actions/apicall';
import Cookies from "js-cookie";
import cancelIcon from '../../../images/cancelIcon.png';
import submitIcon from '../../../images/submitIcon.png';
import Submit from '../reusable/Submit';
import TitleProgressBar from '../reusable/TitleProgressBar';

function AddBusinessBottomSheet (props) {
    const [businessName, setBusinessName] = useState('');
    const [showNameBusiness, setShowNameBusiness] = useState(true);
    const [businessState, setBusinessState] = useState('');
    const [showBusinessState, setShowBusinessState] = useState(false);
    const [businessCity, setBusinessCity] = useState('');
    const [showBusinessCity, setShowBusinessCity] = useState(false);
    const [streetAddress, setStreetAddress] = useState('');
    const [showStreetAddress, setShowStreetAddress] = useState(false);
    const [percentage, setPercentage] = useState(25);
    const [showAddBusiness, setShowAddBusiness] = useState(true);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [addErrorText, setAddErrorText] = useState('');

    let accessToken = Cookies.get('access_token') ?? null;
    let userName = Cookies.get('username') ?? null;
    let userId = Cookies.get('rs11_user_id') ?? 0;

    const handleNameBusiness = () => {
        setShowNameBusiness(false);
        setShowBusinessCity(false);
        setShowBusinessState(true);
        setPercentage(50);
        window.dataLayer.push({'event': 'add_business_name'});
    }

    const handleBusinessState = () => {
        window.dataLayer.push({'event': 'add_business_state'});
        setShowBusinessState(false);
        setShowStreetAddress(false);
        setShowBusinessCity(true);
        setPercentage(75);
    }

    const handleBusinessCity = () => {
        window.dataLayer.push({'event': 'add_business_city'});
        setShowBusinessCity(false);
        setShowStreetAddress(true);
        setPercentage(100);
    }

    const handleCloseButtonClick = () => {
        window.dataLayer.push({'event': 'add_business_exit'});
        props.onBottomSheetClose();
    };

    const handleBack = () => {
        if (showBusinessState) {
            setShowBusinessState(false);
            setShowNameBusiness(true);
            setPercentage(25);
        }
        (showBusinessCity) && handleNameBusiness();
        (showStreetAddress) && handleBusinessState();
    }

    const handleAddBusiness = () => {
        let data = {
            company_name: businessName,
            company_state: businessState,
            company_city: businessCity,
            company_address: streetAddress
        }
        
        APICall.AddNewBusiness(data, accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                window.dataLayer.push({'event': 'add_business_submit'});
                setShowAddBusiness(false);
            }
            else {
                setShowErrorMessage(true);
                setAddErrorText(response.data.message);
            }
        })
    }

    const handleExplore = () => {
        props.onBottomSheetClose();
    }


    return(
        <BottomSheet open={props.isBottomSheetOpen} onDismiss={handleCloseButtonClick}
            header={
                <div className="transparent-header">
                    <img className='cancel-icon' height='25px' src={cancelIcon} onClick={handleCloseButtonClick} />
                </div>
            }
        >
            {
                (showAddBusiness) ? (
                <div className='add-business-container'>  
                    <TitleProgressBar 
                        text={'Add Business'} 
                        percentage={percentage} 
                        totalQuestion={4} 
                    />            
                    {
                        (showNameBusiness) && (
                        <div className='add-business-content'>
                            <p className='name-text'>What is the name of the business?</p>
                            <input 
                                className="name-input" 
                                type="text"
                                id='name-of-business'
                                placeholder='Name of the business' 
                                value={businessName}
                                onChange={(e) => setBusinessName(e.target.value)}
                            />
                            {
                                (businessName.trim().length != 0) ? (
                                <button className='next-button enable' onClick={() => handleNameBusiness()}>
                                    <span>Next</span>
                                </button>) : (
                                <button className='next-button'>
                                    <span>Next</span>
                                </button>
                                )
                            }
                        </div>)
                    }
                    {
                        (showBusinessState) && (
                        <div className='add-business-content'>
                            <p className='name-text'>What State is the business in?</p>
                            <input 
                                className="name-input" 
                                type="text"
                                id='state-business'
                                placeholder='State'
                                value={businessState}
                                onChange={(e) => setBusinessState(e.target.value)}
                            />
                            {
                                (businessState.trim().length != 0) ? (
                                <button className='next-button enable' onClick={() => handleBusinessState()}>
                                    <span>Next</span>
                                </button>) : (
                                <button className='next-button'>
                                    <span>Next</span>
                                </button>
                                )
                            }
                        </div>)
                    }
                    {
                        (showBusinessCity) && (
                        <div className='add-business-content'>
                            <p className='name-text'>What city is the business in?</p>
                            <input 
                                className="name-input" 
                                type="text"
                                id='city-business'
                                placeholder='City'
                                value={businessCity}
                                onChange={(e) => setBusinessCity(e.target.value)}
                            />
                            {
                                (businessCity.trim().length != 0) ? (
                                <button className='next-button enable' onClick={() => handleBusinessCity()}>
                                    <span>Next</span>
                                </button>) : (
                                <button className='next-button'>
                                    <span>Next</span>
                                </button>
                                )
                            }
                        </div>)
                    }
                    {
                        (showStreetAddress) && (
                        <div className='add-business-content'>
                            <p className='name-text'>What is the street address of the business?</p>
                            <input 
                                className="name-input" 
                                type="text"
                                id='address-business'
                                placeholder='Business address (Optional)'
                                value={streetAddress}
                                onChange={(e) => setStreetAddress(e.target.value)}
                            />
                            {
                            (showErrorMessage) && (
                                <p className='error-text'>{addErrorText}</p>)
                            }
                            <button className='next-button enable' onClick={handleAddBusiness}>
                                <span>Next</span>
                            </button>
                            <button className='skip-button' onClick={handleAddBusiness}>
                                <span>Skip</span>
                            </button>
                        </div>)
                    }
                    {
                        !(showNameBusiness) && (
                        <button className='back-button' onClick={() => handleBack()}>Back</button>)
                    }
                </div>) : (
                <div className='submit-content'>
                    <img className='submit-image' src={submitIcon} alt='add-image' height='103px' />
                    <p className='message-text'>Thank you! RS11 will email you {userName} when the business has been added.</p>
                    <Submit actionText={'Explore Other Businesses'} callFunction={handleExplore} />
                </div>
                )
            }
        </BottomSheet>
    )
}

export default AddBusinessBottomSheet;